import { render, staticRenderFns } from "./baseDataMaterial.vue?vue&type=template&id=5d7383aa&scoped=true&"
import script from "./baseDataMaterial.vue?vue&type=script&lang=js&"
export * from "./baseDataMaterial.vue?vue&type=script&lang=js&"
import style0 from "./baseDataMaterial.vue?vue&type=style&index=0&id=5d7383aa&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7383aa",
  null
  
)

export default component.exports